import styled, { css } from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../../meta';
import { getLayoutObjFromName } from '../../../helpers';
import { ItemData } from '../../items/ItemData';

export const MasonryItem = ({ item, data, gutter, id }) => {
  const settings = useSettings();
  const { layout, gridImageResize } = settings;
  const { view } = getLayoutObjFromName(layout);
  const { width, height } = item;

  return (
    <Item style={{ width }} $gutter={gutter}>
      <Content $view={view} $gridImageResize={gridImageResize}>
        <ItemData
          data={data}
          imageClassName={`${meta.stylePrefix}-masonry-item-image`}
          imageHeight={height}
          id={id}
        />
      </Content>
    </Item>
  );
};

const Item = styled.div.attrs({
  className: `${meta.stylePrefix}-masonry-item-item`
})`
  background-color: transparent;
  ${({ $gutter }) => $gutter && `padding-bottom: ${$gutter}px;`}
`;

const Content = styled.div.attrs({
  className: `${meta.stylePrefix}-masonry-item-content`
})`
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  & .${meta.stylePrefix}-masonry-item-image {
    width: 100%;

    ${({ $view, $gridImageResize }) =>
      $view === 'grid' &&
      css`
        object-fit: ${$gridImageResize === 'crop' ? 'cover' : 'contain'};
      `}
  }
`;
